// Calculate milliseconds until the next 11:00 AM UTC (tomorrow)

export const getMillisecondsUntilNext11AMUTC = (): number => {
  const now = new Date();
  const nowUTC = new Date(now.getTime() + now.getTimezoneOffset() * 60000);

  // Always schedule for tomorrow at 11:00 AM UTC (NYC 6AM)
  const tomorrow11AMUTC = new Date(nowUTC);
  tomorrow11AMUTC.setUTCDate(tomorrow11AMUTC.getUTCDate() + 1);
  tomorrow11AMUTC.setUTCHours(11, 0, 0, 0);

  return Math.max(0, tomorrow11AMUTC.getTime() - nowUTC.getTime());
};
